/**
 * @file Contém as constantes do usuario
 */
 const usuario = {
    ORIGEM_LOGIN_AD: 'AD',
}
export default usuario;
